import { Injectable } from "@angular/core";
import { CtBinaryOperator, CtModelConfiguration, CTModelDatatableFilter, CtModelDatatableOperators, CtModelService } from "@ctsolution/ct-framework";
import { CtWebapiGenericResponse } from "@ctsolution/ct-webapi";
import { CTConfigurationModel } from "projects/ct-manager/src/app/_core/classes/ct-configuration-model";
import { CtManagerService } from "projects/ct-manager/src/app/_core/lib/ct-manager.service";
import { ItemHandlingRouteData } from "projects/ct-manager/src/app/_core/route-data/item-handling.route-data";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class OrderHandlingInvoiceService {

    invoiceTotal: number = 0;
    private invoiceTotalSubject = new BehaviorSubject<number>(0);
    invoiceTotal$ = this.invoiceTotalSubject.asObservable();

    constructor(private modelService: CtModelService<any>, private managerService: CtManagerService) { }

    async setInvoiceTotal(oid: number): Promise<number> {
        const model = CtModelConfiguration.create().setRouteData(ItemHandlingRouteData());

        const filters = CtModelDatatableOperators
            .create()
            .setFilters([
                CTModelDatatableFilter
                    .create()
                    .setField('Handling.Oid')
                    .setValue(oid)
                    .setOperatorType(CtBinaryOperator.Equal)
            ]);

        const formatConfiguration: CTConfigurationModel = CTConfigurationModel.create();

  await this.managerService.getComponentOverride("formatDigits", "formatConfiguration", formatConfiguration).then((component: any) => {
      return;
    });
        // Converti l'Observable in Promise
        return new Promise((resolve, reject) => {
            this.modelService.getList(model, filters)
                .subscribe({
                    next: (result: CtWebapiGenericResponse<any>) => {
                        this.invoiceTotal = 0;

                        if (result && result.Result?.DataSource?.length) {
                            result.Result?.DataSource.forEach((item: any) => {
                                if (item.Price && item.StartQty) {
                                    this.invoiceTotal += item.Price * item.StartQty;
                                }
                            });
                        }

                        const factor = Math.pow(10, formatConfiguration.formatPrice);
                        this.invoiceTotal = Math.round((this.invoiceTotal + Number.EPSILON) * factor) / factor;

                        // Emetti il nuovo valore
                        this.invoiceTotalSubject.next(this.invoiceTotal);

                        resolve(this.invoiceTotal);
                    },
                    error: (error) => reject(error)
                });
        });
    }

    getPrice() {
        return this.invoiceTotal;
    }
}